import CoreResize from '../../mixins/core-resize'
import AppPage from '../../mixins/app-page'

import AppTitle from '../app-title'
import AppBtnShare from '../app-btn-share'
import AppImgBg from '../app-img-bg'
import AppImg from '../app-img'
import AppResume from '../app-resume'
import AppFadein from '../app-fadein'
import AppBtn from '../app-btn'
import AppGallerySlideshow from '../app-gallery-slideshow'
import AppBtnFilter from '../app-btn-filter'

export default
{
    name: 'page-gallery',

    mixins:
    [
        AppPage,
        CoreResize
    ],

    components: {
        AppTitle,
        AppBtnShare,
        AppImgBg,
        AppImg,
        AppResume,
        AppFadein,
        AppBtn,
        AppGallerySlideshow,
        AppBtnFilter
    },

    watch:
    {
        contentPage: '_sortImages',
        isSlideshowHidden: 'onIsSlideshowHiddenChange'
    },

    data()
    {
        return {
            images: [],
            imagesShown: 0,
            isMoreBtnEnable: false,
            empty: true,
            isSlideshowHidden: true,
            isSlideshowTranslating: false,
            slideshowActiveImage: null,
            imageURL: null,
            filterVideoGame: null,
            isFilterChanging: false,
            videoGames: this.contentGlobal.videoGames
        }
    },

    created()
    {
        this.imagesOriginal = JSON.parse(JSON.stringify(this.contentPage.content))

        this.videoGames = [this.contentPage.gameOverall].concat(this.videoGames)

        this._onFilterVideoGame(0)

        if (this.$route.params.slug)
        {
            const image = this.imagesOriginal.filter((img, i) =>
            {
                if (img.slug === this.$route.params.slug)
                {
                    img.index = i
                    return img
                }

                return false
            })

            this.imageURL = image[0]
        }

        // Force intro animation
        setTimeout(() =>
        {
            this.empty = false
        }, 1000)

        document.addEventListener('keydown', this._handleKeydown)

        this.eventHub.$on('page-gallery:toggle-is-slideshow-hidden', this._toggleIsSlideshowHidden)

        this.eventHub.$on('page-gallery:get-is-zoomed', this._getIsZoomed)
    },

    mounted()
    {
        if (this.imageURL)
        {
            if (this.imageURL.index < 8)
            {
                this.imagesShown = 9
            }
            else
            {
                this.imagesShown = this.imageURL.index + (3 - (this.imageURL.index % 3))
            }

            this._sortImages()

            this.$nextTick(() =>
            {
                let id = 0

                for (let i = 0, l = this.images.length; i < l; i += 1)
                {
                    if (this.images[i].id === this.imageURL.index)
                    {
                        id = i
                    }
                }

                this._clickOnImage(id)
            })
        }

        this.eventHub.$emit('bg-change', '/static/bg/bg-gallery.jpg')
    },

    destroyed()
    {
        document.removeEventListener('keydown', this._handleKeydown)

        this.eventHub.$off('page-gallery:toggle-is-slideshow-hidden', this._toggleIsSlideshowHidden)

        this.eventHub.$off('page-gallery:get-is-zoomed', this._getIsZoomed)
    },

    methods:
    {
        // WATCHERS
        onIsSlideshowHiddenChange()
        {
            if (this.isSlideshowHidden)
            {
                this.eventHub.$emit('menu:show-items')

                this.slideshowActiveImage = null
            }
            else
            {
                this.eventHub.$emit('menu:hide-items')
            }
        },

        // CORE
        onResized()
        {
            this._sortImages()
        },

        // KEYBOARD ACTIONS
        _handleKeydown(event)
        {
            if (event.keyCode === 27)
            {
                if (this.isSlideshowZoomed)
                {
                    this.eventHub.$emit('app-gallery-slideshow:toggle-is-zoomed', false)
                }
                else
                {
                    this._toggleIsSlideshowHidden(true)
                }
            }
        },

        // TOGGLES
        _toggleIsSlideshowHidden(value = !this.isSlideshowHidden)
        {
            this.isSlideshowHidden = value

            if (this.isSlideshowHidden)
            {
                this.$router.push(this.$root.getPageURLFromID('gallery'))
            }
        },

        // ACTIONS FROM HTML
        _clickOnImage(index)
        {
            this.isSlideshowTranslating = true

            this.$nextTick(() =>
            {
                this.isSlideshowTranslating = false
            })

            this.isSlideshowHidden = false

            this.slideshowActiveImage = this.images[index]

            this.$router.push(`${this.$root.getPageURLFromID('gallery')}/${this.slideshowActiveImage.slug}`)
        },

        // GETTER
        _getIsZoomed(value)
        {
            this.isSlideshowZoomed = value
        },

        _moreImages()
        {
            this.imagesShown += 9

            this._sortImages()
        },

        _moreCheck()
        {
            let isMoreBtnEnable = false
            const imagesShown = this.imagesShown

            if (imagesShown < this.imagesOriginalFiltered.length)
            {
                isMoreBtnEnable = true
            }

            this.isMoreBtnEnable = isMoreBtnEnable
        },

        _sortImages()
        {
            this.$nextTick(() =>
            {
                // Sort images from it date
                this.imagesOriginal.sort((a, b) => b.id - a.id)

                this.images = []
                this.images.length = 0

                this.imagesOriginalFiltered = this.imagesOriginal.filter(image =>
                    image.videoGameID === parseInt(this.filterVideoGame.id, 10) || this.filterVideoGame.id === 0
                )

                this.images = this.imagesOriginalFiltered.filter((image, index) =>
                    index < this.imagesShown
                )

                this._moreCheck()

                this.$nextTick(() => this.$emit('load', this))
            })
        },

        _getVideoGameFromID(id)
        {
            return this.videoGames.find(game => parseInt(game.id, 10) === id)
        },

        _onFilterVideoGame(index)
        {
            this.filterVideoGame = this._getVideoGameFromID(index)

            if (index === 0)
            {
                this.eventHub.$emit('bg-change', '/static/bg/bg-empty.jpg')
            }
            else
            {
                this.eventHub.$emit('bg-change', this.filterVideoGame.cover)
            }

            this.isFilterChanging = true
            setTimeout(() =>
            {
                this.isFilterChanging = false
            }, 1000)

            this.imagesShown = 0
            this._moreImages()
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-gallery/script.js